import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "アクション履歴")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "アクション履歴が見つかりませんでした。", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "rad8 pad5 mc posRe w100",
  style: {}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_OneRoomHistoryContent = _resolveComponent("OneRoomHistoryContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "RoomHistoryDetailModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_ctx.hists)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_RoomsLoader)
                    ]))
                  : (_ctx.hists.length == 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_12)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hists, (hist, histindex) => {
                          return (_openBlock(), _createBlock(_component_OneRoomHistoryContent, {
                            hist: hist,
                            room: _ctx.room,
                            key: `${histindex}${hist.created_at}${(_ctx.hists || []).length}${_ctx.room ? _ctx.room.id : null}`
                          }, null, 8, ["hist", "room"]))
                        }), 128))
                      ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}